import { render, staticRenderFns } from "./EventJoin.vue?vue&type=template&id=6bd77550"
import script from "./EventJoin.vue?vue&type=script&lang=ts"
export * from "./EventJoin.vue?vue&type=script&lang=ts"
import style0 from "./EventJoin.vue?vue&type=style&index=0&id=6bd77550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports